 //export const API_URL = "http://localhost:5080/api/";
//export const API_URL = "https://ahcrecruitment-qa-api.azurewebsites.net/api/";
export const API_URL = "https://ahcrecruitment-api-bsakdgc2bjarghdp.uaenorth-01.azurewebsites.net/api/";
